import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=64314532&scoped=true&"
import script from "./Proposal.vue?vue&type=script&lang=js&"
export * from "./Proposal.vue?vue&type=script&lang=js&"
import style0 from "./Proposal.vue?vue&type=style&index=0&id=64314532&prod&lang=scss&"
import style1 from "./Proposal.vue?vue&type=style&index=1&id=64314532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64314532",
  null
  
)

export default component.exports